import React, { useMemo, useState } from "react";
import DOMPurify from "dompurify";
import {
  FormHelperText,
  Stack,
  TableCell,
  TableRow,
  Typography,
  Tooltip,
  Box,
  CircularProgress,
  IconButton,
  Button,
} from "@mui/material";
//import { processesApi } from "api";
import {
  formatDate,
  getFirstSentence,
  getTranslation,
  getUserData,
  getUserDataValue,
  shouldTruncate,
} from "common/utilities";
import UserAvatar from "./UserAvatar";
import { DeleteForever, Edit as EditIcon } from "@mui/icons-material";
import { useSelectedOrganization, useTranslations } from "hooks";
// import { TaskDetailDialog } from "./dialogs";
import { StartedProcess } from "./ProcessItem";
import { Link, useNavigate } from "react-router-dom";
import { BaseTask } from "model/activitiesModel";
import BlockIcon from "@mui/icons-material/Block";
import { ClockIcon } from "@mui/x-date-pickers";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Monitor } from "hooks/useMonitor";
import SubstitutesMenu from "./menus/SubstitutesMenu";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
export interface TaskDetail extends BaseTask {
  designerid: string;
  user_picture: string | null;
  process_description: string;
  process_enddate: string | null;
  process_idprocessmodel: number;
  process_startdate: string | null;
  process_userdata: string;
  processduration: number;
  processmodeldeleted: boolean;
  flownodetype: number;
  idtype: number;
  iduser: number;
  previous: number;
  taskduration: number | null;
  timeindoing: number;
  timetotakeover: number;
  userfullname: string | null;
}
interface TaskItemProps {
  handleClick: (
    task: TaskDetail,
    type: "delete" | "terminate" | "disclose" | "reschedule"
  ) => void;
  task: TaskDetail;
  process: StartedProcess;
  filters: Record<string, any>;
  setSelectedTask: (task: BaseTask) => void;
  userDataKeys: string[];
  monitors: Monitor[];
  isMonitorsLoading: boolean;
  // expandedCells: Record<string, boolean>;
  // toggleExpand: (key: string, e: React.MouseEvent) => void;
  openFullContentDialog: (content: string, title: string) => void;
  refresh: () => void;
}

const TaskItem: React.FC<TaskItemProps> = React.memo(({
  handleClick,
  filters,
  task,
  process,
  setSelectedTask,
  userDataKeys,
  monitors,
  isMonitorsLoading,
  // expandedCells,
  // toggleExpand,
  openFullContentDialog,
  refresh,
}) => {
  // const selectedOrganization = useSelectedOrganization();
  // const [user] = useState<StatisticUser | null>(null);
  const translations = useTranslations();
  const navigation = useNavigate()

  const activeTimers = useMemo(
    () =>
      monitors
        .filter((timer) => {
          return timer.idprocesstoken === task.idprocesstoken;
        })
        .map((timer) => timer.starttime),
    [monitors, task.idprocesstoken]
  );

  // useEffect(() => {
  //   (async () => {
  //     if (task.iduser) {
  //       const { data } = await usersApi.get(`${task.iduser}`);
  //       setUser(data.user);
  //     }
  //   })();
  // }, [task.iduser]);

  const userDataMap = useMemo(() => {
    try {
      const data = getUserData(task.process_userdata);
      return data;
    } catch (e) {
      return {};
    }
  }, [task.process_userdata]);

  // State for participant edit mode

  // State for participant edit mode
  const [isEditingParticipant, setIsEditingParticipant] = useState(false);

  // const { sendSnack } = useSnackbar();

  // const handleEarlyTermination = async (task: TaskDetail) => {
  //   try {
  //     const { data } = await processesApi.post(`/${task.idprocesstoken}/intermediateevents/terminate`);
  //     sendSnack({ message: data.responsemessage, type: "success" });
  //   } catch { }
  // };

  const fixHeight = {
    // maxHeight: 130,
    maxHeight: "100px",
    // minHeight: 130,
    // boxSizing: "border-box",
    overflowY: "auto",
  };
  const [isHovered, setIsHovered] = useState(false);
  const selectedOrganization = useSelectedOrganization();
  const isAdmin = selectedOrganization?.administrator;

  return (
    <React.Fragment>
      <TableRow
        id={`task-row-${process.process_idprocessmodel}`}

        sx={{
          "& > td": {
            p: 2,
            lineHeight: 1,
            ...fixHeight,
          },
          '&:last-child td, &:last-child th': {
            borderBottom: 'none'
          },
          cursor: "pointer",
          "&:hover": { backgroundColor: (_) => _.palette.divider },
        }}
        onClick={() => setSelectedTask(task)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <TableCell
          id="process-header-rows"
          sx={{
            // py: 0,
            opacity: 1,
            position: "sticky",
            left: 0,
            zIndex: 10,
            borderLeft: "1px solid #ddd",
            backgroundColor: isHovered ? "#e0e0e0" : "white"
          }}
        >
          <Stack>
            <Stack
              // alignItems="center"
              spacing={0.5}
              minWidth="400px"
              // flex={1}
              // width="auto"
              direction="row"
              // maxWidth="150px"
              display="flex"
              flexDirection="column"
            >
              {/* <Link
                onClick={(e) => void e.stopPropagation()}
                to={`/dashboard/process/edit/${process.process_idprocessmodel}`}
                style={{
                  fontWeight: "bold",
                  textDecoration: "none",
                  color: "black "
                }}
                state={{ designerid: task.designerid }}> */}
              <span
                style={{
                  textDecoration: "none",
                  fontWeight: "bold",
                  flex: 1,
                  paddingBottom: 8,
                  color: "black"
                }}
              >
                {process.process_description}
              </span>
              <span>
                <AccountTreeIcon sx={{ verticalAlign: "middle", color: "primary.main", mr: 2, ":hover": { color: "secondary.main" } }} onClick={(e) => { e.stopPropagation(); navigation(`/dashboard/process/edit/${process.process_idprocessmodel}`, { state: { designerid: task.designerid } }) }} />
                {process.processmodelname || "no name"}
                <FormHelperText>
                  {getTranslation(translations, "pm.process.started_at")}
                  {formatDate(process.process_startdate)}
                </FormHelperText>
              </span>
              {/* <ArrowForwardSharp fontSize={"small"} />
              <Link
                onClick={(e) => void e.stopPropagation()}
                to={`/dashboard/process/edit/${process.process_idprocessmodel}`}
                style={{ fontWeight: "bold" }}
                state={{ designerid: task.designerid }}
              >
                {`${task.processmodelname}`}
              </Link> */}
              {/* </Link> */}
            </Stack>
          </Stack>
        </TableCell>
        {/* <TableCell> */}
        {/* <ArrowForwardSharp fontSize={"small"} /> */}
        {/* <Box
            sx={{ maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis" }}
          >
            <Link
              onClick={(e) => void e.stopPropagation()}
              to={`/dashboard/process/edit/${process.process_idprocessmodel}`}
              style={{
                fontWeight: "bold",
              }}
              state={{ designerid: task.designerid }}
            >
              {task.processmodelname}
            </Link>
          </Box> */}
        {/* </TableCell> */}
        {userDataKeys.map((key) => {
          const value = userDataMap[key];
          // const cellKey = `${task.idprocesstoken}-${key}`;
          // const isExpanded = expandedCells[cellKey];
          const needsTruncation = value && shouldTruncate(getUserDataValue(value));
          // console.log({ cellKey, isExpanded, needsTruncation, value });

          return (
            <TableCell key={key}>
              <Box>
                {value ? (
                  <Stack spacing={0.5}>
                    <Box
                      sx={{
                        maxHeight: needsTruncation ? '100px' : 'none',
                        overflow: 'hidden',
                        position: 'relative',
                        '&::after': needsTruncation ? {
                          content: '""',
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: '20px',
                          background: (theme) => `linear-gradient(to bottom, transparent 0%, ${theme.palette.background.paper} 100%)`,
                        } : {},
                      }}
                    >
                      <Box
                        sx={{ whiteSpace: "pre-wrap" }}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(getUserDataValue(value))
                        }}
                      />
                    </Box>
                    {needsTruncation && (
                      <Button
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          openFullContentDialog(getUserDataValue(value), process.process_description);
                        }}
                        sx={{ alignSelf: "flex-start", minWidth: "auto", p: 0.5 }}
                      >
                        {getTranslation(translations, "generic.full_view")}
                      </Button>
                    )}
                  </Stack>
                ) : (
                  "N/A"
                )}
              </Box>
            </TableCell>
          );
        })}
        <TableCell>
          <Stack>
            <span>
              <Typography>{task.flownodename}</Typography>
              {process.state === 1 && (
                <FormHelperText>
                  {getTranslation(translations, "pm.process.started_at")}
                  {formatDate(process.startdoing)}
                </FormHelperText>
              )}
              {process.state === 0 && (
                <FormHelperText>
                  {/* in todo dal */}
                  {getTranslation(translations, "pm.process.created")} {" "}
                  {formatDate(process.created)}
                </FormHelperText>
              )}
            </span>
          </Stack>
        </TableCell>
        <TableCell>
            <Typography>
              {task.state === 0
                ? getTranslation(translations, "pm.label.process_status.todo")
                : getTranslation(translations, "pm.label.process_status.doing")}
            </Typography>
          </TableCell>
        <TableCell>
          <Stack
            direction="row"
            gap={2}
            alignItems="center"
            onClick={(e) => {
              if (isEditingParticipant) {
                e.stopPropagation();
              }
            }}
          >
            {task.idtype === 3 ? (
              <Stack>
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <ClockIcon />
                    <Typography>
                      {getTranslation(translations, "events.intermediate_catch")}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Tooltip
                      title={getTranslation(
                        translations,
                        "events.intermediate_catch.disclose"
                      )}
                    >
                      <IconButton
                        id="disclose-intermediate-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClick(task, "disclose");
                        }}
                        color="primary"
                      >
                        <LockOpenIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title={getTranslation(
                        translations,
                        "events.intermediate_catch.reschedule"
                      )}
                    >
                      <IconButton
                        id="disclose-intermediate-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClick(task, "reschedule");
                        }}
                        color="primary"
                      >
                        <CalendarMonthIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Stack>
                <Stack direction="column">
                  {isMonitorsLoading ? (
                    <CircularProgress />
                  ) : (
                    activeTimers.map((starttime) => (
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        key={starttime}
                      >
                        {new Date(starttime).toLocaleString()}
                      </Typography>
                    ))
                  )}
                </Stack>
              </Stack>
            ) : isAdmin ? (
              <SubstitutesMenu
                idOrganization={selectedOrganization?.id || 0}
                idProcess={process.idprocess}
                idToken={task.idprocesstoken}
                currentUser={task.iduser ? {
                  id: task.iduser,
                  firstname: task.userfullname?.split(" ")[0] || "",
                  lastname: task.userfullname?.split(" ").slice(1).join(" ") || "",
                  picture: task.user_picture,
                } : null}
                isEditing={isEditingParticipant}
                onEditClick={() => setIsEditingParticipant(true)}
                onAssignmentChange={(newUser) => {
                  // Refresh the list to reflect the new assignment without opening detail
                  refresh();
                  // Close edit mode after assignment
                  setIsEditingParticipant(false);
                }}
              />
            ) : task.iduser ? (
              <Stack direction="row" spacing={0.5}>
                <UserAvatar
                  user={{
                    picture: task.user_picture,
                    email: "",
                    firstname: "",
                    lastname: "",
                  }}
                />
                <Typography>{task.userfullname}</Typography>
              </Stack>
            ) : (
              <Typography color="textSecondary">
                {getTranslation(translations, "monitor.no_participant")}
              </Typography>
            )}
          </Stack>
        </TableCell>
        <TableCell sx={{ borderRight: "1px solid #ddd", }}>
          <Stack direction="row" spacing={1}>
            <Tooltip title={getTranslation(translations, "tooltip.terminate.process")}>
              <span>
                <IconButton
                  id="terminate-btn"
                  onClick={(e) => {
                    handleClick(task, "terminate");
                    e.stopPropagation();
                  }}
                  color="primary"
                  disabled={!isAdmin}
                >
                  <BlockIcon />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title={getTranslation(translations, "tooltip.delete.process")}>
              <span>
                <IconButton
                  id="delete-4ever-btn"
                  onClick={(e) => {
                    handleClick(task, "delete");
                    e.stopPropagation();
                  }}
                  color="primary"
                  disabled={!isAdmin}
                >
                  <DeleteForever />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        </TableCell>
      </TableRow>
    </React.Fragment >
  );
});

export default TaskItem;
